import { render, staticRenderFns } from "./Shades.vue?vue&type=template&id=c3d68156&scoped=true&"
import script from "./Shades.vue?vue&type=script&lang=js&"
export * from "./Shades.vue?vue&type=script&lang=js&"
import style0 from "./Shades.vue?vue&type=style&index=0&id=c3d68156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d68156",
  null
  
)

export default component.exports